<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          ASSET REPORT
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Summary/Detail
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="reportOptions.type" @change="updateReportType">
          <el-radio-button label="detail">Detail</el-radio-button>
          <el-radio-button label="summary">Summary</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <!--
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Periods/Dates
      </el-col>
      <el-col :span="21">
        <el-radio-group v-model="reportOptions.dates" @change="updateReportDates">
          <el-radio-button label="datesAll">All</el-radio-button>
          <el-radio-button label="datesPeriod">Period</el-radio-button>
          <el-radio-button label="datesPosted">Posting Date</el-radio-button>
          <el-radio-button label="datesEffective">Effective Date</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <div v-if="reportOptions.dates==='datesPeriod'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">Starting Period</el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">Ending Period</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.period_start" :multiple="false" placeholder="First Period">
            <el-option
              v-for="opt in allCodes.periods"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.start"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <el-select v-model="selectedCodes.period_end" :multiple="false" placeholder="Last Period">
            <el-option
              v-for="opt in allCodes.periods"
              :key="opt.id"
              :label="opt.id + ' - ' + opt.start"
              :value="opt.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesPosted'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">Posting Date Start</el-col>
        <el-col :span="3" />
        <el-col :span="4">Posting Date End</el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.time_posted_start" />
        </el-col>
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.time_posted_end" />
        </el-col>
      </el-row>
    </div>

    <div v-if="reportOptions.dates==='datesEffective'" class="m-top-20">
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">Effective Date Start <sup>**</sup></el-col>
        <el-col :span="3" />
        <el-col :span="4">Effective Date End <sup>**</sup></el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.effective_date_start" />
        </el-col>
        <el-col :span="3" />
        <el-col :span="4">
          <DateField v-model="selectedCodes.effective_date_end" />
        </el-col>
      </el-row>
      <el-row v-if="reportOptions.dates==='datesEffective'" type="flex" align="middle" justify="start">
        <el-col :span="3" />
        <el-col :span="21"><p><sup>**</sup> Posting Date is used if Effective Date is not Set</p></el-col>
      </el-row>
    </div>
    -->

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Company
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.company_id"
          :multiple="false" placeholder="All">
          <el-option
            v-for="opt in allCodes.companies"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Production
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.production_id"
          :multiple="false" placeholder="All">
          <el-option
            v-for="opt in allCodes.productions"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="selectRow">
      <el-col :span="3" class="right">
        Series
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.series_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.series"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Location
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.location_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.locations"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="selectRow">
      <el-col :span="3" class="right">
        Set
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.set_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.sets"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Free Field
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.free_field_1_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.freefield1"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
    <!--
      <el-col :span="3" class="right">
        Source Code
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedCodes.source_code_id"
          :multiple="true" placeholder="All">
          <el-option
            v-for="opt in allCodes.sourcecodes"
            :key="opt.id"
            :label="opt.code + ' - ' + opt.name"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      -->
      <el-col :span="3" class="right">
        Assets
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.asset" placeholder="All">
          <el-option value="true" label="Show Only Assets"></el-option>
          <el-option value="false" label="Hide Assets"></el-option>
          <el-option :value="undefined">All Transactions</el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="(allCodes.currencies||[]).length > 1" type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Currency
      </el-col>
      <el-col :span="4">
        <el-select v-model="selectedCodes.currency_id">
          <el-option
            v-for="opt in currencies"
            :key="opt.id"
            :label="opt.code"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Convert To
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.report_currency_id">
          <el-option
            v-for="opt in currencies"
            :key="opt.id"
            :label="opt.code"
            :value="opt.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.format">
          <el-option
            v-for="opt in reportOutputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" class="right">
        Include
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.pos.include"></el-checkbox> POs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.aps.include"></el-checkbox> APs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.jes.include"></el-checkbox> JEs
      </el-col>
      <el-col :span="1">
        <el-checkbox v-model="transactionTypes.pcs.include"></el-checkbox> PCs
      </el-col>
    </el-row>
    <div class="clear"></div>
    <el-row type="flex" align="middle" justify="end" class="section">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Account Selection
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-radio-group v-model="reportOptions.accountQuickPick" @change="updateAccounts" :disabled="loading || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button :label="'All'">Skip Banks</el-radio-button>
          <el-radio-button :label="'all'">All</el-radio-button>
          <el-radio-button label="expenses">Expenses Only</el-radio-button>
          <el-radio-button label="balance">Balance Sheet Only</el-radio-button>
          <el-radio-button label="none">None</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-show="reportOptions.accountQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-transfer
          ref="accountTransfer"
          v-model="selectedCodes.account_id"
          :data="accounts"
          :titles="[ 'Unselected Accounts', 'Selected Accounts' ]"
          :props="{ key: 'id', label: 'display_name' }"
          filterable
          filter-placeholder="Search Accounts"
        >
        </el-transfer>
        <!--
          :filter-method="filterMethod"
        -->
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-button plain @click="generateReport" :disabled="disableReportRun">
        Run report
      </el-button>
    </el-row>
    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
    <el-row v-if="showJson">
      <el-col :span="1">
        <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
          Run Customized Report
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
  import { capitalizeFirstLetter } from '@/utils/helpers/StringOperations'
  import { reportMixins } from '@/Mixins/Reports'
  import DateField from '@/components/InputComponents/DateField.vue'

  export default {
    name: 'AssetReport',
    components: { DateField },
    mixins: [ reportMixins ],
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          type: 'detail',
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'pdf',
          currencyFactor: undefined,
          report_currency_id: 1
        },
        allCodes: {},    // Show codes, e.g. accounts, series, locations, sets, etc.
        selectedCodes: {
          period_start: undefined,
          period_end: undefined,
          time_posted_start: undefined,
          time_posted_end: undefined,
          effective_date_start: undefined,
          effective_date_end: undefined,
          account_id: [],
          series_id: [],
          location_id: [],
          set_id: [],
          free_field_1_id: [],
          free_field_2_id: [],
          company_id: undefined,
          production_id: undefined,
          source_code_id: [],
          asset: 'true',
          currency_id: []
        },
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: 'general_ledger_detail'
        },
        vendors: undefined,
        transactionTypes: {     // Types of transactions and whether we need them or not
          'aps': { name: 'AP', include: true },
          'jes': { name: 'JE', include: true },
          'pcs': { name: 'PC', include: true },
          'cks': { name: 'CK', include: false },
          'pos': { name: 'PO', include: false }
        },
        unserializedData: {      // Raw data from API
          aps: {
            headers: {},
            lines: {}
          },
          jes: {
            headers: {},
            lines: {}
          },
          pcs: {
            headers: {},
            lines: {}
          },
          cks: {
            headers: {},
            lines: {}
          },
          pos: {
            headers: {},
            lines: {}
          }
        },
        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        sortedAccounts: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        bankRelatedAccounts: [],     // Do not show bank related accounts
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false
      }
    },

    computed: {
      username () { return this.$store.getters.getUser.username },
      includedTypes () {
        if (this.selectedCodes.source_code_id.length) this.transactionTypes.jes.include = true
        return Object.values(this.transactionTypes).filter(types => types.include === true).map(type => type.name)
      },
      accounts () {
        let accountsNew = []
        for (let i in this.allCodes.accounts) {
          if (this.allCodes.accounts[i].type.toLowerCase() === 'header') continue
          accountsNew[i] = this.allCodes.accounts[i]
          accountsNew[i]['display_name'] = this.allCodes.accounts[i]['code'] + ' - ' + this.allCodes.accounts[i]['name']
        }
        return accountsNew
      },
      accountsNoBanking () {
        return this.allCodes.accounts.filter(acct => (acct.type.toLowerCase() !== 'header') && (!this.bankRelatedAccounts.includes(acct.id)))
      },
      currencies () {
        if (typeof this.allCodes.currencies !== 'undefined' && this.allCodes.currencies.length > 0) {
          return sortObjectByProperty(this.allCodes.currencies, 'id')
        } else {
          return []
        }
      },
      dateStart () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_start) || {}).start || '0000/00/00'

          case 'datesEffective':
            return this.selectedCodes.effective_date_start || '0000/00/00'

          case 'datesPosted':
            return this.selectedCodes.time_posted_start || '0000/00/00'

          default:
            return 'ALL'
        }
      },
      dateEnd () {
        switch (this.reportOptions.dates) {
          case 'datesPeriod':
            return (this.allCodes.periods.find(({id}) => id === this.selectedCodes.period_end) || {}).end || '9999/99/99'

          case 'datesEffective':
            return this.selectedCodes.effective_date_end || '9999/99/99'

          case 'datesPosted':
            return this.selectedCodes.time_posted_end || '9999/99/99'

          default:
            return 'ALL'
        }
      }
    },
    methods: {
      resetComponent () {
        this.reportJson = this.vendors = this.sortedAccounts = undefined
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        this.jasperSettings.reportName = 'general_ledger_' + type
      },
      updateReportDates (type) {
        this.selectedCodes.period_start = this.selectedCodes.period_end = this.selectedCodes.time_posted_start = this.selectedCodes.time_posted_end = this.selectedCodes.effective_date_start = this.selectedCodes.effective_date_end = undefined
      },
      updateAccounts (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.selectedCodes.account_id = []
            break
          case 'All':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.accountsNoBanking.map(acct => acct.id)
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.map(acct => acct.id)
            break
          case 'expenses':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.toLowerCase().match('expense')).map(acct => acct.id)
            break
          case 'balance':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => {
              if (type.toLowerCase().match('asset') || type.toLowerCase().match('liability') || type.toLowerCase().match('income')) return true
            }).map(acct => acct.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      addExpenseAccounts () {
        this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.match('EXPENSE')).map(acct => acct.id)
      },
      includeAps ({target}) {
        this.transactionTypes.aps.include = target.checked
      },
      includeJes ({target}) {
        this.transactionTypes.jes.include = target.checked
      },
      includePcs ({target}) {
        this.transactionTypes.pcs.include = target.checked
      },
      includeCks ({target}) {
        this.transactionTypes.cks.include = target.checked
      },
      includePos ({target}) {
        this.transactionTypes.pos.include = target.checked
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },
      buildCsvData (sortedAccounts) {
        if (!sortedAccounts || !Array.isArray(sortedAccounts)) return false

        let detailedColumns = { 'Company': 'company_name', 'Production': 'production_name', 'Transaction Type': 'trans_type', 'Transaction ID': 'trans_number', 'Transaction Description': 'transaction_description', 'Transaction Line Description': 'line_desc', 'Account': 'account', 'Account Description': 'account_name', 'Vendor Code': 'transaction_vendor', 'Vendor Name': 'vendor_name', 'Series': 'series', 'Location': 'location', 'Set': 'set', 'FF1': 'free_field_1', 'FF2': 'free_field_2', 'Tax Code': 'tax_code', 'Asset': 'asset', 'Document Number': 'doc_number', 'Document Date': 'doc_date', 'Posting Date': 'transaction_time_posted', 'Effective Date': 'transaction_effective_date', 'Period': 'period_id', 'PO Number': 'po_number', 'Check Number': 'payment_number', 'Bank Recon': 'recon', 'Amount': 'amount' }
        let summaryColumns = { 'Account': 'account_number', 'Account Description': 'account_desc', 'Amount': 'account_total' }
        // detailedColumns = { 'account_number': 'account', 'account_desc': 'account_name', 'amount': 'amount', 'account': 'account', 'period': 'transaction_period_name', 'transaction_vendor': 'vendor_name', 'vendor_id': 'transaction_vendor', 'account_header': 'account_header', 'series': 'series', 'location': 'location', 'set': 'set', 'free_field_1': 'free_field_1', 'free_field_2': 'free_field_2', 'free_field_3': 'free_field_3', 'free_field_4': 'free_field_4', 'asset': 'asset', 'tax_code': 'tax_code', 'line_desc': 'line_desc', 'recon': 'recon', 'trans_type': 'trans_type', 'trans_number': 'trans_number', 'line_number': 'line_number', 'doc_date': 'doc_date', 'doc_number': 'doc_number', 'company': 'company_name', 'production': 'production_name', 'batch': 'transaction_batch_name', 'transaction_credits_decimal': 'transaction_credits_decimal', 'transaction_number': 'doc_number', 'transaction_confirmation_number': 'transaction_confirmation_number', 'transaction_original_trx_number': 'transaction_original_trx_number', 'transaction_ledger': 'transaction_ledger_id', 'transaction_description': 'transaction_description', 'transaction_date': 'doc_date', 'transaction_time_posted': 'transaction_time_posted', 'transaction_batch': 'transaction_batch', 'transaction_source_code': 'source_code', 'transaction_effective_date': 'transaction_effective_date', 'transaction_debits_decimal': 'transaction_debits_decimal', 'transaction_status': 'transaction_status', 'transaction_id': 'subledger_id', 'transaction_period': 'transaction_period_id', 'payment_number': 'payment_number', 'transaction_date_due': 'transaction_date_due', 'transaction_vendor_code': 'transaction_vendor', 'transaction_payment_combine_checks': 'transaction_payment_combine_checks', 'transaction_payment_check_split': 'transaction_payment_check_split', 'transaction_state': 'transaction_state', 'transaction_discount_decimal': 'transaction_discount_decimal', 'transaction_payment_check_pickup': 'transaction_payment_check_pickup', 'transaction_payment_type': 'transaction_payment_type', 'transaction_payment_confirmation_number': 'transaction_payment_confirmation_number', 'transaction_amount_decimal': 'transaction_amount_decimal' }
        // let sipraColumnMap = { 'account_number': 'account', 'account_desc': 'account_name', 'amount': 'amount', 'account': 'account', 'period': 'transaction_period_name', 'transaction_vendor': 'vendor_name', 'vendor_id': 'transaction_vendor', 'account_header': 'account_header', 'series': 'series', 'location': 'location', 'set': 'set', 'free_field_1': 'free_field_1', 'free_field_2': 'free_field_2', 'free_field_3': 'free_field_3', 'free_field_4': 'free_field_4', 'asset': 'asset', 'tax_code': 'tax_code', 'line_desc': 'line_desc', 'recon': 'recon', 'trans_type': 'trans_type', 'trans_number': 'trans_number', 'doc_date': 'doc_date', 'doc_number': 'doc_number', 'company': 'company_name', 'production': 'production_name', 'batch': 'transaction_batch_name', 'transaction_credits_decimal': 'transaction_credits_decimal', 'transaction_number': 'doc_number', 'transaction_confirmation_number': 'transaction_confirmation_number', 'transaction_original_trx_number': 'transaction_original_trx_number', 'transaction_ledger': 'transaction_ledger_id', 'transaction_description': 'transaction_description', 'transaction_date': 'doc_date', 'transaction_time_posted': 'transaction_time_posted', 'transaction_batch': 'transaction_batch', 'transaction_source_code': 'source_code', 'transaction_effective_date': 'transaction_effective_date', 'transaction_debits_decimal': 'transaction_debits_decimal', 'transaction_status': 'transaction_status', 'transaction_id': 'subledger_id', 'transaction_period': 'transaction_period_id', 'payment_number': 'payment_number', 'transaction_date_due': 'transaction_date_due', 'transaction_vendor_code': 'transaction_vendor', 'transaction_payment_combine_checks': 'transaction_payment_combine_checks', 'transaction_payment_check_split': 'transaction_payment_check_split', 'transaction_state': 'transaction_state', 'transaction_discount_decimal': 'transaction_discount_decimal', 'transaction_payment_check_pickup': 'transaction_payment_check_pickup', 'transaction_payment_type': 'transaction_payment_type', 'transaction_payment_confirmation_number': 'transaction_payment_confirmation_number', 'transaction_amount_decimal': 'transaction_amount_decimal' }

        // TODO: Sipra Output
        let columnMap = (this.reportOptions.type === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          let ledgerData = []

          sortedAccounts.map(accountCode => {
            if (this.reportOptions.type === 'summary') {
              accountCode.transaction = undefined
              ledgerData.push(accountCode)
            } else {
              accountCode.transaction.map(row => ledgerData.push(row))
            }
          })

          this.disableReportRun = false
          let finalCsv = this.createCsv(ledgerData, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },

      buildGlReport (sortedAccounts) {
        return new Promise((resolve, reject) => {
          let json = {
            report: {
              report_title: 'Asset Report',
              report_subtitle: '',
              report_name: 'general_ledger_detail',
              printed_by: this.username,
              date_run: this.today(),
              company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id).name) : this.allCodes.companies[0].name,
              project: (this.selectedCodes.production_id) ? (this.allCodes.productions.find(({id}) => id === this.selectedCodes.production_id).name) : this.allCodes.productions[0].name,

              currency: (this.reportOptions.report_currency_id) ? (this.allCodes.currencies.find(({id}) => id === this.reportOptions.report_currency_id).code) : this.currencies[0].code,
              period: this.dateStart + ' - ' + this.dateEnd,
              date_start: this.dateStart,
              date_end: this.dateEnd,
              grand_total: '',
              transactions: 'All',
              episodes: (this.selectedCodes.series_id && this.selectedCodes.series_id.length > 0) ? (this.allCodes.series.find(({id}) => this.selectedCodes.series_id.includes(id)).code) : 'All',
              locations: (this.selectedCodes.location_id && this.selectedCodes.location_id.length > 0) ? (this.allCodes.locations.find(({id}) => this.selectedCodes.location_id.includes(id)).code) : 'All',
              sets: (this.selectedCodes.set_id && this.selectedCodes.set_id.length > 0) ? (this.allCodes.sets.find(({id}) => this.selectedCodes.set_id.includes(id)).code) : 'All',
              free_fields: (this.selectedCodes.free_field_1_id && this.selectedCodes.free_field_1_id.length > 0) ? (this.allCodes.freefield1.find(({id}) => this.selectedCodes.free_field_1_id.includes(id)).code) : 'All',
              sourcecodes: (this.selectedCodes.source_code_id && this.selectedCodes.source_code_id.length > 0) ? (this.allCodes.sourcecodes.find(({id}) => this.selectedCodes.source_code_id.includes(id)).code) : 'All',
              accounts: capitalizeFirstLetter(this.reportOptions.accountQuickPick),
              data: []
            }
          }

          // Put finished data here
          let ledgerData = []

          // TODO Use selected accounts instead of all accounts
          this.allCodes.accounts.map((data) => {
            // Place account code into report
            let account = {}
            account.account_desc = data.name
            account.account_number = data.code
            account.account_id = data.id
            account.account_parent = data.parent

            // Now look through actual data and put into the proper group
            if (sortedAccounts.current[data.code]) {
              account.account_total = this.sumRecursive(sortedAccounts.current[data.code], 'amount')
              account.transaction = sortedAccounts.current[data.code]
              ledgerData.push(account)
            }
          })

          json.report.grand_total = this.sumRecursive(ledgerData, 'account_total')
          json.report.data = ledgerData

          resolve(json)
        })
      },
      generateReport () {
        this.loading = true
        this.disableReportRun = true

        if (this.reportOptions.format === 'csv') {
          this.getReportData('glreport')
            .then((resSorted) => {
              this.loading = false
              return this.buildGlReport(resSorted.data)
            })
            .then((resReport) => {
              return this.buildCsvData(resReport.report.data)
            })
            .then((resCsv) => {
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true)
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          this.getReportData('glreport')
            .then((resSorted) => {
              // console.log(resSorted.data)
              return this.buildGlReport(resSorted.data)
            })
            .then(json => {
              this.reportJson = json
              this.prettyJson = JSON.stringify(json, null, 2)
              return this.getJsonUrl(json)
            })
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        }
      }
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
          return this.allCodes.banks
        })
        .then(banks => {
          banks.map(bank => {
            this.bankRelatedAccounts.push(bank.default_account_cash_id)
            this.bankRelatedAccounts.push(bank.default_account_clearing_id)
            this.bankRelatedAccounts.push(bank.default_account_deposits_id)
            this.bankRelatedAccounts.push(bank.default_account_discount_id)
          })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/AssetReportCustom.vue